// extracted by mini-css-extract-plugin
export default {"noModulesIcon":"PIM8sEZo"};